import * as React from 'react';

import { IPaymentDetails } from 'src/model/credit.model';

import './CreditsPaymentDetailsTable.scss';
import CreditsPaymentDetailsRow from './CreditsPaymentDetailsRow';

interface ICreditsPaymentDetailsTableProps {
  payments: IPaymentDetails[];
  customerCode: string;
}

class CreditsPaymentDetailsTable extends React.Component<
  ICreditsPaymentDetailsTableProps,
  any
> {
  public render() {
    return (
      <div className="rp-credits-payment-details-table">
        <div className="rp-credits-details-container">
          <div className="rp-credits-p-details-header col-2">
            <h4>Invoice</h4>
          </div>
          <div className="rp-credits-p-details-header col-2">
            <h4>Invoice Date</h4>
          </div>
          <div className="rp-credits-p-details-header col-2">
            <h4>Total Amt</h4>
          </div>
          <div className="rp-credits-p-details-header col-2">
            <h4>Payment Amt</h4>
          </div>
          <div className="rp-credits-p-details-header col-4">
            <h4>Reason for remaining amount</h4>
          </div>
        </div>
        <div className="rp-credits-p-details-data-container">
          {this.props.payments.map(payment => (
            <CreditsPaymentDetailsRow
              key={payment.id}
              payment={payment}
              customerCode={this.props.customerCode}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default CreditsPaymentDetailsTable;
